import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'SignIn',
		component: () => import('../views/SignIn.vue'),
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/signup',
		name: 'SignUp',
		component: () => import('../views/SignUp.vue'),
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/forgotpassword',
		name: 'ForgotPassword',
		component: () => import('../views/ForgotPassword.vue'),
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/changepassword/:token',
		name: 'ChangePassword',
		props: true,
		component: () => import('../views/ChangePassword.vue'),
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import('../views/Dashboard.vue'),
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/subscription/:id',
		name: 'Subscription',
		props: true,
		component: () => import('../views/Subscription.vue'),
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/terms',
		name: 'Terms',
		component: () => import('../views/Terms.vue'),
		meta: {
			requiresAuth: false
		}
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.state.token) {
			if (!store.getters.isLoggedIn) {
				await store.dispatch('fetchUser')
			}
			next()
		} else {
			next({name: 'SignIn'})
		}
	}
    
	if (to.matched.some(record => !record.meta.requiresAuth)) {
		if (store.state.token) {
			if (!store.getters.isLoggedIn) {
				await store.dispatch('fetchUser')
			}
			if (to.name === 'Terms') next()
			else  next({name: 'Dashboard'})
		} else {
			next()
		}
	}
})


export default router
